import { QueryClient } from "@tanstack/react-query";

/**
 * Cliente de TanStack Query de la aplicación.
 *
 * Es el único caché de datos de servidor (`docs/frontend_architecture.md`,
 * Pr. 4). Defaults conservadores: sin reintentos automáticos en error (la
 * lógica de 401/refresh ya vive en `lib/api`) y un `staleTime` pequeño que las
 * features pueden afinar por query.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
